export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
};

export type Account = {
  __typename?: "Account";
  addressCity: Maybe<Scalars["String"]["output"]>;
  addressPostalCode: Maybe<Scalars["String"]["output"]>;
  addressStreet: Maybe<Scalars["String"]["output"]>;
  contactEmail: Maybe<Scalars["String"]["output"]>;
  contactPhone: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  onboardingCompleted: Scalars["Boolean"]["output"];
  orgNumber: Maybe<Scalars["String"]["output"]>;
  privacyUrl: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  termsUrl: Maybe<Scalars["String"]["output"]>;
  type: AccountTypeEnum;
  updatedAt: Scalars["DateTime"]["output"];
  website: Maybe<Scalars["String"]["output"]>;
};

export type AccountMember = {
  __typename?: "AccountMember";
  account: Account;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  isContactPerson: Scalars["Boolean"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  user: User;
};

export type AccountSettingsType = {
  __typename?: "AccountSettingsType";
  brandFooterText: Maybe<Scalars["String"]["output"]>;
  brandLogoUrl: Maybe<Scalars["String"]["output"]>;
  brandPrimaryColor: Maybe<Scalars["String"]["output"]>;
  emailConfigured: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  legalConfigured: Scalars["Boolean"]["output"];
  mailFromName: Maybe<Scalars["String"]["output"]>;
  mailReplyTo: Maybe<Scalars["String"]["output"]>;
  onboardingCompleted: Scalars["Boolean"]["output"];
  paymentNotificationEmail: Maybe<Scalars["String"]["output"]>;
  pokerPhaseEnabled: Scalars["Boolean"]["output"];
  privacyUrl: Maybe<Scalars["String"]["output"]>;
  sectionsConfigured: Scalars["Float"]["output"];
  sectionsTotal: Scalars["Float"]["output"];
  smsConfigured: Scalars["Boolean"]["output"];
  smsDefaultSender: Maybe<Scalars["String"]["output"]>;
  startInvoiceNo: Scalars["Float"]["output"];
  termsUrl: Maybe<Scalars["String"]["output"]>;
  vippsClientIdMasked: Maybe<Scalars["String"]["output"]>;
  vippsConfigured: Scalars["Boolean"]["output"];
  vippsMerchantSerialNumberMasked: Maybe<Scalars["String"]["output"]>;
  vippsValidated: Scalars["Boolean"]["output"];
};

export enum AccountTypeEnum {
  Platform = "PLATFORM",
  Tenant = "TENANT",
}

export type BalancingMove = {
  __typename?: "BalancingMove";
  seatId: Scalars["ID"]["output"];
  seatNumber: Scalars["Int"]["output"];
  tableNumber: Scalars["Int"]["output"];
};

export type BalancingSuggestionDto = {
  __typename?: "BalancingSuggestionDto";
  kind: BalancingSuggestionKind;
  moves: Array<BalancingMove>;
  reason: Scalars["String"]["output"];
  tableNumber: Maybe<Scalars["Int"]["output"]>;
};

export enum BalancingSuggestionKind {
  BalanceMove = "BALANCE_MOVE",
  BreakTable = "BREAK_TABLE",
  OverCap = "OVER_CAP",
}

export enum BeatTheProEntryStateEnum {
  Lost = "LOST",
  Undecided = "UNDECIDED",
  Won = "WON",
}

export type BeatTheProExtra = {
  __typename?: "BeatTheProExtra";
  allIn: Scalars["Boolean"]["output"];
  bet: Scalars["Float"]["output"];
  state: BeatTheProEntryStateEnum;
};

export type BeatTheProExtraDto = {
  allIn?: Scalars["Boolean"]["input"];
  bet: Scalars["Float"]["input"];
  state?: BeatTheProEntryStateEnum;
};

export type BestBallLeaderboard = {
  __typename?: "BestBallLeaderboard";
  players: Array<GolfLeaderboardPlayer>;
  teams: Array<BestBallLeaderboardTeam>;
};

export type BestBallLeaderboardTeam = {
  __typename?: "BestBallLeaderboardTeam";
  holesRegistred: Scalars["Float"]["output"];
  points: Scalars["Float"]["output"];
  rank: Maybe<Scalars["Float"]["output"]>;
  score: Scalars["Float"]["output"];
  scores: Array<PolfEventScore>;
  scoresBestBall: Array<PolfEventScore>;
  strokes: Scalars["Float"]["output"];
  strokesNet: Scalars["Float"]["output"];
  team: PolfEventTeam;
};

export type BlindLevelInput = {
  ante: Scalars["Int"]["input"];
  bigBlind: Scalars["Int"]["input"];
  breakAfterMinutes?: InputMaybe<Scalars["Int"]["input"]>;
  durationMinutes: Scalars["Int"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  index: Scalars["Int"]["input"];
  smallBlind: Scalars["Int"]["input"];
};

export enum BlindTemplateKeyEnum {
  Deep = "DEEP",
  Standard = "STANDARD",
  Turbo = "TURBO",
}

export type BlindTemplateLevelType = {
  __typename?: "BlindTemplateLevelType";
  ante: Scalars["Int"]["output"];
  bigBlind: Scalars["Int"]["output"];
  breakAfterMinutes: Maybe<Scalars["Int"]["output"]>;
  durationMinutes: Scalars["Int"]["output"];
  smallBlind: Scalars["Int"]["output"];
};

export type BreakTableResult = {
  __typename?: "BreakTableResult";
  moves: Array<BalancingMove>;
  poker: PolfEventPoker;
};

export type BrregAddress = {
  __typename?: "BrregAddress";
  city: Maybe<Scalars["String"]["output"]>;
  postalCode: Maybe<Scalars["String"]["output"]>;
  street: Maybe<Scalars["String"]["output"]>;
};

export type BrregCompanyType = {
  __typename?: "BrregCompanyType";
  address: Maybe<BrregAddress>;
  businessAddress: Maybe<BrregAddress>;
  employeeCount: Maybe<Scalars["Float"]["output"]>;
  homepage: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  orgNumber: Scalars["String"]["output"];
  organizationForm: Maybe<Scalars["String"]["output"]>;
  registeredInVat: Scalars["Boolean"]["output"];
};

export type Course = {
  __typename?: "Course";
  aiImported: Scalars["Boolean"]["output"];
  country: CourseCountryEnum;
  createdAt: Scalars["DateTime"]["output"];
  holes: Array<CourseHole>;
  id: Scalars["ID"]["output"];
  isValid: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  polfEvents: PolfEvent;
  status: CourseStatusEnum;
  tees: Maybe<Array<CourseTee>>;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum CourseCountryEnum {
  Ad = "AD",
  Ae = "AE",
  Af = "AF",
  Ag = "AG",
  Ai = "AI",
  Al = "AL",
  Am = "AM",
  An = "AN",
  Ao = "AO",
  Aq = "AQ",
  Ar = "AR",
  As = "AS",
  At = "AT",
  Au = "AU",
  Aw = "AW",
  Ax = "AX",
  Az = "AZ",
  Ba = "BA",
  Bb = "BB",
  Bd = "BD",
  Be = "BE",
  Bf = "BF",
  Bg = "BG",
  Bh = "BH",
  Bi = "BI",
  Bj = "BJ",
  Bm = "BM",
  Bn = "BN",
  Bo = "BO",
  Br = "BR",
  Bs = "BS",
  Bt = "BT",
  Bv = "BV",
  Bw = "BW",
  By = "BY",
  Bz = "BZ",
  Ca = "CA",
  Cc = "CC",
  Cd = "CD",
  Cf = "CF",
  Cg = "CG",
  Ch = "CH",
  Ci = "CI",
  Ck = "CK",
  Cl = "CL",
  Cm = "CM",
  Cn = "CN",
  Co = "CO",
  Cr = "CR",
  Cs = "CS",
  Cu = "CU",
  Cv = "CV",
  Cx = "CX",
  Cy = "CY",
  Cz = "CZ",
  De = "DE",
  Dj = "DJ",
  Dk = "DK",
  Dm = "DM",
  Do = "DO",
  Dz = "DZ",
  Ec = "EC",
  Ee = "EE",
  Eg = "EG",
  Eh = "EH",
  Er = "ER",
  Es = "ES",
  Et = "ET",
  Fi = "FI",
  Fj = "FJ",
  Fk = "FK",
  Fm = "FM",
  Fo = "FO",
  Fr = "FR",
  Ga = "GA",
  Gb = "GB",
  Gd = "GD",
  Ge = "GE",
  Gf = "GF",
  Gg = "GG",
  Gh = "GH",
  Gi = "GI",
  Gl = "GL",
  Gm = "GM",
  Gn = "GN",
  Gp = "GP",
  Gq = "GQ",
  Gr = "GR",
  Gs = "GS",
  Gt = "GT",
  Gu = "GU",
  Gw = "GW",
  Gy = "GY",
  Hk = "HK",
  Hm = "HM",
  Hn = "HN",
  Hr = "HR",
  Ht = "HT",
  Hu = "HU",
  Id = "ID",
  Ie = "IE",
  Il = "IL",
  Im = "IM",
  In = "IN",
  Io = "IO",
  Iq = "IQ",
  Ir = "IR",
  Is = "IS",
  It = "IT",
  Je = "JE",
  Jm = "JM",
  Jo = "JO",
  Jp = "JP",
  Ke = "KE",
  Kg = "KG",
  Kh = "KH",
  Ki = "KI",
  Km = "KM",
  Kn = "KN",
  Kp = "KP",
  Kr = "KR",
  Kw = "KW",
  Ky = "KY",
  Kz = "KZ",
  La = "LA",
  Lb = "LB",
  Lc = "LC",
  Li = "LI",
  Lk = "LK",
  Lr = "LR",
  Ls = "LS",
  Lt = "LT",
  Lu = "LU",
  Lv = "LV",
  Ly = "LY",
  Ma = "MA",
  Mc = "MC",
  Md = "MD",
  Mg = "MG",
  Mh = "MH",
  Mk = "MK",
  Ml = "ML",
  Mm = "MM",
  Mn = "MN",
  Mo = "MO",
  Mp = "MP",
  Mq = "MQ",
  Mr = "MR",
  Ms = "MS",
  Mt = "MT",
  Mu = "MU",
  Mv = "MV",
  Mw = "MW",
  Mx = "MX",
  My = "MY",
  Mz = "MZ",
  Na = "NA",
  Nc = "NC",
  Ne = "NE",
  Nf = "NF",
  Ng = "NG",
  Ni = "NI",
  Nl = "NL",
  No = "NO",
  Np = "NP",
  Nr = "NR",
  Nu = "NU",
  Nz = "NZ",
  Om = "OM",
  Pa = "PA",
  Pe = "PE",
  Pf = "PF",
  Pg = "PG",
  Ph = "PH",
  Pk = "PK",
  Pl = "PL",
  Pm = "PM",
  Pn = "PN",
  Pr = "PR",
  Ps = "PS",
  Pt = "PT",
  Pw = "PW",
  Py = "PY",
  Qa = "QA",
  Re = "RE",
  Ro = "RO",
  Ru = "RU",
  Rw = "RW",
  Sa = "SA",
  Sb = "SB",
  Sc = "SC",
  Sd = "SD",
  Se = "SE",
  Sg = "SG",
  Sh = "SH",
  Si = "SI",
  Sj = "SJ",
  Sk = "SK",
  Sl = "SL",
  Sm = "SM",
  Sn = "SN",
  So = "SO",
  Sr = "SR",
  St = "ST",
  Sv = "SV",
  Sy = "SY",
  Sz = "SZ",
  Tc = "TC",
  Td = "TD",
  Tf = "TF",
  Tg = "TG",
  Th = "TH",
  Tj = "TJ",
  Tk = "TK",
  Tl = "TL",
  Tm = "TM",
  Tn = "TN",
  To = "TO",
  Tr = "TR",
  Tt = "TT",
  Tv = "TV",
  Tw = "TW",
  Tz = "TZ",
  Ua = "UA",
  Ug = "UG",
  Um = "UM",
  Us = "US",
  Uy = "UY",
  Uz = "UZ",
  Va = "VA",
  Vc = "VC",
  Ve = "VE",
  Vg = "VG",
  Vi = "VI",
  Vn = "VN",
  Vu = "VU",
  Wf = "WF",
  Ws = "WS",
  Ye = "YE",
  Yt = "YT",
  Za = "ZA",
  Zm = "ZM",
  Zw = "ZW",
}

export type CourseDraftDto = {
  __typename?: "CourseDraftDto";
  country: CourseCountryEnum;
  holes: Array<CourseDraftHoleDto>;
  name: Scalars["String"]["output"];
  sources: Array<CourseDraftSourceDto>;
  tees: Array<CourseDraftTeeDto>;
};

export type CourseDraftHoleDto = {
  __typename?: "CourseDraftHoleDto";
  index: Scalars["Int"]["output"];
  number: Scalars["Int"]["output"];
  par: Scalars["Int"]["output"];
  tees: Array<CourseDraftHoleTeeDto>;
};

export type CourseDraftHoleInputDto = {
  index: Scalars["Int"]["input"];
  number: Scalars["Int"]["input"];
  par: Scalars["Int"]["input"];
  tees: Array<CourseDraftHoleTeeInputDto>;
};

export type CourseDraftHoleTeeDto = {
  __typename?: "CourseDraftHoleTeeDto";
  length: Scalars["Float"]["output"];
  teeName: Scalars["String"]["output"];
};

export type CourseDraftHoleTeeInputDto = {
  length: Scalars["Float"]["input"];
  teeName: Scalars["String"]["input"];
};

export type CourseDraftSourceDto = {
  __typename?: "CourseDraftSourceDto";
  title: Scalars["String"]["output"];
  uri: Scalars["String"]["output"];
};

export type CourseDraftTeeDto = {
  __typename?: "CourseDraftTeeDto";
  courseRating: Scalars["Float"]["output"];
  par: Scalars["Int"]["output"];
  slope: Scalars["Float"]["output"];
  teeName: Scalars["String"]["output"];
};

export type CourseDraftTeeInputDto = {
  courseRating: Scalars["Float"]["input"];
  par: Scalars["Int"]["input"];
  slope: Scalars["Float"]["input"];
  teeName: Scalars["String"]["input"];
};

export type CourseHole = {
  __typename?: "CourseHole";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  index: Scalars["Float"]["output"];
  number: Scalars["Float"]["output"];
  par: Scalars["Float"]["output"];
  tees: Maybe<Array<CourseHoleTees>>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type CourseHoleTees = {
  __typename?: "CourseHoleTees";
  length: Maybe<Scalars["Float"]["output"]>;
  teeId: Scalars["ID"]["output"];
};

export type CourseHoleTeesDto = {
  length?: InputMaybe<Scalars["Float"]["input"]>;
  teeId: Scalars["ID"]["input"];
};

export enum CourseStatusEnum {
  Archived = "ARCHIVED",
  Draft = "DRAFT",
  Published = "PUBLISHED",
}

export type CourseTee = {
  __typename?: "CourseTee";
  courseRating: Scalars["Float"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  default: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  par: Scalars["Float"]["output"];
  slope: Scalars["Float"]["output"];
  teeName: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type CreateCourseDto = {
  country?: InputMaybe<CourseCountryEnum>;
  name: Scalars["String"]["input"];
};

export type CreateCourseFromDraftDto = {
  country: CourseCountryEnum;
  holes: Array<CourseDraftHoleInputDto>;
  name: Scalars["String"]["input"];
  tees: Array<CourseDraftTeeInputDto>;
};

export type CreateCourseHoleDto = {
  index: Scalars["Float"]["input"];
  number: Scalars["Float"]["input"];
  par: Scalars["Float"]["input"];
  tees?: InputMaybe<Array<CourseHoleTeesDto>>;
};

export type CreateCourseTeeDto = {
  courseRating: Scalars["Float"]["input"];
  par: Scalars["Float"]["input"];
  slope: Scalars["Float"]["input"];
  teeName: Scalars["String"]["input"];
};

export type CreatePolfEventConsentDto = {
  consentKey: Scalars["String"]["input"];
  consentText: Scalars["String"]["input"];
  consentedAt: Scalars["DateTime"]["input"];
  type: PolfEventConsentTypeEnum;
};

export type CreatePolfEventDto = {
  courseId: Scalars["ID"]["input"];
  date: Scalars["DateTime"]["input"];
  hcpFactor?: Scalars["Float"]["input"];
  mode: PolfEventModeEnum;
  name: Scalars["String"]["input"];
  ranking?: InputMaybe<PolfEventRankingEnum>;
  registration?: InputMaybe<PolfEventRegistrationDto>;
};

export type CreatePolfEventHoleCompetitionDto = {
  chipValue?: Scalars["Float"]["input"];
  description: Scalars["String"]["input"];
  holeId: Scalars["ID"]["input"];
  type: PolfEventHoleCompetitionTypeEnum;
};

export type CreatePolfEventHoleCompetitionEntryDto = {
  /** Only used for competition type Beat the pro */
  beatTheProExtra?: InputMaybe<BeatTheProExtraDto>;
  polfEventPlayerId: Scalars["ID"]["input"];
  /** Distance in cm/meter if closest/longest, or chip value if beat the pro */
  value: Scalars["Float"]["input"];
};

export type CreatePolfEventHoleCompetitionOpponentDto = {
  countryCode?: InputMaybe<Scalars["String"]["input"]>;
  mobileNumber: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export type CreatePolfEventPaymentDto = {
  consents?: InputMaybe<Array<CreatePolfEventConsentDto>>;
  /** When the event has `registration.playerPicksTee` enabled, the picked tee id travels with the payment so it survives the Vipps round-trip. Ignored when the flag is off; the course default tee is used instead. */
  courseTeeId?: InputMaybe<Scalars["String"]["input"]>;
  mobileNumber: Scalars["String"]["input"];
  paymentMethod: VippsPaymentMethodEnum;
};

export type CreatePolfEventPlayerDto = {
  countryCode?: InputMaybe<Scalars["String"]["input"]>;
  courseTeeId: Scalars["ID"]["input"];
  email?: InputMaybe<Scalars["String"]["input"]>;
  hcp?: InputMaybe<Scalars["Float"]["input"]>;
  memberNo?: InputMaybe<Scalars["String"]["input"]>;
  mobileNumber: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export type CreatePolfEventTeamDto = {
  customName?: InputMaybe<Scalars["String"]["input"]>;
};

export type DevReseedResult = {
  __typename?: "DevReseedResult";
  durationMs: Scalars["Int"]["output"];
};

export enum DevReseedScope {
  Full = "FULL",
  SeedTenant = "SEED_TENANT",
}

export type GolfLeaderboard = {
  __typename?: "GolfLeaderboard";
  players: Array<GolfLeaderboardPlayer>;
};

export type GolfLeaderboardPlayer = {
  __typename?: "GolfLeaderboardPlayer";
  holesRegistred: Scalars["Float"]["output"];
  player: PolfEventPlayer;
  points: Scalars["Float"]["output"];
  rank: Maybe<Scalars["Float"]["output"]>;
  score: Scalars["Float"]["output"];
  scores: Array<PolfEventScore>;
  strokes: Scalars["Float"]["output"];
  strokesNet: Scalars["Float"]["output"];
};

export type LeaderboardUnion =
  BestBallLeaderboard | GolfLeaderboard | PolfLeaderboard | ScrambleLeaderboard;

export enum LevelDirection {
  Next = "NEXT",
  Prev = "PREV",
}

export type MoveSeatInput = {
  seatId: Scalars["ID"]["input"];
  seatNumber: Scalars["Int"]["input"];
  tableNumber: Scalars["Int"]["input"];
};

export type Mutation = {
  __typename?: "Mutation";
  accountAddMember: AccountMember;
  accountCreate: Account;
  accountRemoveMember: Scalars["Boolean"]["output"];
  accountSetContactPerson: Array<AccountMember>;
  courseCreate: Course;
  courseCreateFromDraft: Course;
  courseDelete: Course;
  courseHoleAdd: Course;
  courseHoleDelete: Course;
  courseStatusUpdate: Course;
  courseTeeCreate: CourseTee;
  courseTeeDelete: CourseTee;
  courseTeeSetDefault: Array<CourseTee>;
  courseTeeUpdate: CourseTee;
  courseUpdate: Course;
  courseUpdateFromDraft: Course;
  courseUpdateHoles: Course;
  currentOpponentHoleCompetitionEntryAdd: PolfEventBeatTheProPlayer;
  currentOpponentHoleCompetitionEntryDelete: PolfEventBeatTheProPlayer;
  currentOpponentHoleCompetitionEntrySetResult: PolfEventBeatTheProPlayer;
  currentPlayerHoleCompetitionEntryCreate: PolfEventHoleCompetitionEntry;
  currentPlayerHoleCompetitionEntryRemove: PolfEventHoleCompetitionEntry;
  currentPlayerHoleCompetitionEntryUpdate: PolfEventHoleCompetitionEntry;
  currentPlayerPokerStackUpdate: PolfEventPokerSeat;
  currentPlayerScoreSubmitFlight: Scalars["Boolean"]["output"];
  currentPlayerScoreUpdate: Array<PolfEventMobileScore>;
  devReseed: DevReseedResult;
  myAccountAddMember: AccountMember;
  myAccountProfileUpdate: Account;
  myAccountRemoveMember: Scalars["Boolean"]["output"];
  myAccountSettingsUpdate: AccountSettingsType;
  paymentCapture: VippsPaymentDetails;
  /** Create player on an authorized payment that is missing a playerId */
  paymentCreatePlayerBasedOnPaymentRecord: VippsPayment;
  paymentDeleteEmptyRecords: Array<VippsPayment>;
  paymentRefund: VippsPaymentDetails;
  /** Updated all records that do not have an end state from Vipps */
  paymentUpdateAllRecords: Array<VippsPayment>;
  polfEventChipValuesUpdate: PolfEvent;
  polfEventClosePolfEvent: PolfEvent;
  polfEventCopyData: PolfEvent;
  polfEventCreate: PolfEvent;
  polfEventDelete: PolfEvent;
  polfEventFinishPolfEvent: PolfEvent;
  polfEventFlightAdd: PolfEventFlight;
  polfEventFlightAddPlayer: PolfEventFlight;
  polfEventFlightAddTeam: PolfEventFlight;
  polfEventFlightRemove: PolfEventFlight;
  polfEventFlightRemovePlayer: PolfEventFlight;
  polfEventFlightRemoveTeam: PolfEventFlight;
  polfEventFlightUpdate: PolfEventFlight;
  polfEventHoleCompetitionCreate: PolfEventHoleCompetition;
  polfEventHoleCompetitionEntryRemove: PolfEventHoleCompetitionEntry;
  polfEventHoleCompetitionEntryUpdate: PolfEventHoleCompetitionEntry;
  polfEventHoleCompetitionOpponentAdd: PolfEventHoleCompetition;
  polfEventHoleCompetitionOpponentUpdate: PolfEventHoleCompetition;
  polfEventHoleCompetitionRemove: PolfEventHoleCompetition;
  polfEventHoleCompetitionUpdate: PolfEventHoleCompetition;
  polfEventOperatorCreate: PolfEventOperator;
  polfEventOperatorRevoke: PolfEventOperator;
  polfEventOperatorSendLink: PolfEventOperator;
  polfEventOperatorSendLinkToAll: OperatorBulkSendResult;
  polfEventPlayerAdd: PolfEventPlayer;
  polfEventPlayerAddMultiple: Array<PolfEventPlayer>;
  polfEventPlayerDistributeInFlights: Array<PolfEventFlight>;
  polfEventPlayerOtherPaymentCreate: PolfEventPlayerOtherPayment;
  polfEventPlayerOtherPaymentDelete: PolfEventPlayerOtherPayment;
  polfEventPlayerPaymentReminder: PolfEventPlayer;
  polfEventPlayerRemove: PolfEventPlayer;
  polfEventPlayerScoreUpdate: Maybe<PolfEventScore>;
  polfEventPlayerUpdate: PolfEventPlayer;
  polfEventPokerAddTable: PolfEventPoker;
  polfEventPokerAllowPlayerStackUpdateSet: PolfEventPoker;
  polfEventPokerBalancingApply: PolfEventPoker;
  polfEventPokerBlindStructureUpdate: PolfEventPoker;
  polfEventPokerBreakTable: BreakTableResult;
  polfEventPokerClockAdjust: PolfEventPoker;
  polfEventPokerClockPause: PolfEventPoker;
  polfEventPokerClockResume: PolfEventPoker;
  polfEventPokerClockStart: PolfEventPoker;
  polfEventPokerFinalTableRedraw: PolfEventPoker;
  polfEventPokerFinish: PolfEventPoker;
  polfEventPokerLevelAdvance: PolfEventPoker;
  polfEventPokerPayoutStructureUpdate: PolfEventPoker;
  polfEventPokerPhaseEnable: PolfEvent;
  polfEventPokerPrizePoolUpdate: PolfEventPoker;
  polfEventPokerRemoveLastTable: PolfEventPoker;
  polfEventPokerReorderElimination: PolfEventPoker;
  polfEventPokerSeatEliminate: PolfEventPoker;
  polfEventPokerSeatLockToggle: PolfEventPoker;
  polfEventPokerSeatMove: PolfEventPokerSeat;
  polfEventPokerSeatRestore: PolfEventPoker;
  polfEventPokerSeatStackUpdate: PolfEventPokerSeat;
  polfEventPokerSeatSwap: PolfEventPokerSeat;
  polfEventPokerSeatWithdraw: PolfEventPoker;
  polfEventPokerSeatsPerTableUpdate: PolfEventPoker;
  polfEventPokerSendSeatSms: PolfEventPokerSmsResult;
  polfEventPokerShowChipLeaderboardSet: PolfEventPoker;
  polfEventPokerStart: PolfEventPoker;
  polfEventPokerUsePayoutsSet: PolfEventPoker;
  polfEventPokerVoiceAnnouncementsSet: PolfEventPoker;
  polfEventPublicAddPlayerVipps: VippsPayment;
  polfEventPublicUpdatePlayer: PolfEventPlayer;
  polfEventReopenPolfEvent: PolfEvent;
  polfEventRequestUpdatedInfo: PolfEvent;
  polfEventSendInvites: PolfEvent;
  polfEventStartPolfEvent: PolfEvent;
  polfEventTeamAdd: PolfEventTeam;
  polfEventTeamAddPlayer: PolfEventTeam;
  polfEventTeamAutogenerate: Array<PolfEventTeam>;
  polfEventTeamDelete: PolfEventTeam;
  polfEventTeamDistributeInFlights: Array<PolfEventFlight>;
  polfEventTeamRemovePlayer: PolfEventTeam;
  polfEventTeamResetName: PolfEventTeam;
  polfEventTeamSetCaptain: PolfEventTeam;
  polfEventTeamUpdate: PolfEventTeam;
  polfEventUpdate: PolfEvent;
  selectAccount: SelectAccountResponse;
  sendSms: SentSms;
  sponsorCreate: Sponsor;
  sponsorDelete: Scalars["Boolean"]["output"];
  sponsorLogoUploadComplete: Sponsor;
  sponsorLogoUploadUrl: SponsorLogoUpload;
  sponsorUpdate: Sponsor;
};

export type MutationAccountAddMemberArgs = {
  accountId: Scalars["ID"]["input"];
  email: Scalars["String"]["input"];
};

export type MutationAccountCreateArgs = {
  contactPersonEmail: Scalars["String"]["input"];
  contactPersonName: Scalars["String"]["input"];
  contactPhone?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  orgNumber?: InputMaybe<Scalars["String"]["input"]>;
  slug: Scalars["String"]["input"];
  website?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationAccountRemoveMemberArgs = {
  accountId: Scalars["ID"]["input"];
  userId: Scalars["ID"]["input"];
};

export type MutationAccountSetContactPersonArgs = {
  accountId: Scalars["ID"]["input"];
  memberId: Scalars["ID"]["input"];
};

export type MutationCourseCreateArgs = {
  createCourseDto: CreateCourseDto;
};

export type MutationCourseCreateFromDraftArgs = {
  createCourseFromDraftDto: CreateCourseFromDraftDto;
};

export type MutationCourseDeleteArgs = {
  courseId: Scalars["ID"]["input"];
};

export type MutationCourseHoleAddArgs = {
  courseId: Scalars["ID"]["input"];
  createCourseHoleDto: CreateCourseHoleDto;
};

export type MutationCourseHoleDeleteArgs = {
  courseId: Scalars["ID"]["input"];
  holeId: Scalars["ID"]["input"];
};

export type MutationCourseStatusUpdateArgs = {
  courseId: Scalars["ID"]["input"];
  updateCourseStatusDto: UpdateCourseStatusDto;
};

export type MutationCourseTeeCreateArgs = {
  courseId: Scalars["ID"]["input"];
  createCourseTeeDto: CreateCourseTeeDto;
};

export type MutationCourseTeeDeleteArgs = {
  courseId: Scalars["ID"]["input"];
  courseTeeId: Scalars["ID"]["input"];
};

export type MutationCourseTeeSetDefaultArgs = {
  courseId: Scalars["ID"]["input"];
  courseTeeId: Scalars["ID"]["input"];
};

export type MutationCourseTeeUpdateArgs = {
  courseTeeId: Scalars["ID"]["input"];
  updateCourseTeeDto: UpdateCourseTeeDto;
};

export type MutationCourseUpdateArgs = {
  courseId: Scalars["ID"]["input"];
  updateCourseDto: UpdateCourseDto;
};

export type MutationCourseUpdateFromDraftArgs = {
  courseId: Scalars["ID"]["input"];
  updateCourseFromDraftDto: UpdateCourseFromDraftDto;
};

export type MutationCourseUpdateHolesArgs = {
  courseId: Scalars["ID"]["input"];
  updateCourseHoleDtos: Array<UpdateCourseHoleDto>;
};

export type MutationCurrentOpponentHoleCompetitionEntryAddArgs = {
  createPolfEventHoleCompetitionEntryDto: CreatePolfEventHoleCompetitionEntryDto;
};

export type MutationCurrentOpponentHoleCompetitionEntryDeleteArgs = {
  polfEventHoleCompetitionEntryId: Scalars["ID"]["input"];
  polfEventPlayerId: Scalars["ID"]["input"];
};

export type MutationCurrentOpponentHoleCompetitionEntrySetResultArgs = {
  polfEventHoleCompetitionEntryId: Scalars["ID"]["input"];
  polfEventPlayerId: Scalars["ID"]["input"];
  state: BeatTheProEntryStateEnum;
};

export type MutationCurrentPlayerHoleCompetitionEntryCreateArgs = {
  createPolfEventHoleCompetitionEntryDto: CreatePolfEventHoleCompetitionEntryDto;
  polfEventHoleCompetitionId: Scalars["ID"]["input"];
};

export type MutationCurrentPlayerHoleCompetitionEntryRemoveArgs = {
  polfEventHoleCompetitionEntryId: Scalars["ID"]["input"];
};

export type MutationCurrentPlayerHoleCompetitionEntryUpdateArgs = {
  polfEventHoleCompetitionEntryId: Scalars["ID"]["input"];
  updatePolfEventHoleCompetitionEntryDto: UpdatePolfEventHoleCompetitionEntryDto;
};

export type MutationCurrentPlayerPokerStackUpdateArgs = {
  currentStack: Scalars["Float"]["input"];
};

export type MutationCurrentPlayerScoreUpdateArgs = {
  scoreDto: PolfEventScoreDto;
};

export type MutationDevReseedArgs = {
  scope?: DevReseedScope;
};

export type MutationMyAccountAddMemberArgs = {
  email: Scalars["String"]["input"];
};

export type MutationMyAccountProfileUpdateArgs = {
  profile: UpdateAccountProfileInput;
};

export type MutationMyAccountRemoveMemberArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationMyAccountSettingsUpdateArgs = {
  settings: UpdateAccountSettingsInput;
};

export type MutationPaymentCaptureArgs = {
  paymentId: Scalars["ID"]["input"];
};

export type MutationPaymentCreatePlayerBasedOnPaymentRecordArgs = {
  paymentId: Scalars["ID"]["input"];
};

export type MutationPaymentRefundArgs = {
  paymentId: Scalars["ID"]["input"];
};

export type MutationPolfEventChipValuesUpdateArgs = {
  polfEventId: Scalars["ID"]["input"];
  updatePolfEventChipValues: UpdatePolfEventChipValues;
};

export type MutationPolfEventClosePolfEventArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventCopyDataArgs = {
  polfEventCopyDataDto: PolfEventCopyDataDto;
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventCreateArgs = {
  createPolfEventDto: CreatePolfEventDto;
};

export type MutationPolfEventDeleteArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventFinishPolfEventArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventFlightAddArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventFlightAddPlayerArgs = {
  polfEventFlightId: Scalars["ID"]["input"];
  polfEventPlayerId: Scalars["ID"]["input"];
};

export type MutationPolfEventFlightAddTeamArgs = {
  polfEventFlightId: Scalars["ID"]["input"];
  polfEventTeamId: Scalars["ID"]["input"];
};

export type MutationPolfEventFlightRemoveArgs = {
  polfEventFlightId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventFlightRemovePlayerArgs = {
  flightId: Scalars["ID"]["input"];
  polfEventPlayerId: Scalars["ID"]["input"];
};

export type MutationPolfEventFlightRemoveTeamArgs = {
  flightId: Scalars["ID"]["input"];
  polfEventTeamId: Scalars["ID"]["input"];
};

export type MutationPolfEventFlightUpdateArgs = {
  polfEventFlightId: Scalars["ID"]["input"];
  updatePolfEventFlightDto: UpdatePolfEventFlightDto;
};

export type MutationPolfEventHoleCompetitionCreateArgs = {
  createPolfEventHoleCompetitionDto: CreatePolfEventHoleCompetitionDto;
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventHoleCompetitionEntryRemoveArgs = {
  polfEventHoleCompetitionEntryId: Scalars["ID"]["input"];
};

export type MutationPolfEventHoleCompetitionEntryUpdateArgs = {
  polfEventHoleCompetitionEntryId: Scalars["ID"]["input"];
  updatePolfEventHoleCompetitionEntryDto: UpdatePolfEventHoleCompetitionEntryDto;
};

export type MutationPolfEventHoleCompetitionOpponentAddArgs = {
  createPolfEventHoleCompetitionOpponentDto: CreatePolfEventHoleCompetitionOpponentDto;
  polfEventHoleCompetitionId: Scalars["ID"]["input"];
};

export type MutationPolfEventHoleCompetitionOpponentUpdateArgs = {
  polfEventHoleCompetitionOpponentId: Scalars["ID"]["input"];
  updatePolfEventHoleCompetitionOpponentDto: UpdatePolfEventHoleCompetitionOpponentDto;
};

export type MutationPolfEventHoleCompetitionRemoveArgs = {
  polfEventHoleCompetitionId: Scalars["ID"]["input"];
};

export type MutationPolfEventHoleCompetitionUpdateArgs = {
  polfEventHoleCompetitionId: Scalars["ID"]["input"];
  updatePolfEventHoleCompetitionDto: UpdatePolfEventHoleCompetitionDto;
};

export type MutationPolfEventOperatorCreateArgs = {
  input: PolfEventOperatorCreateDto;
};

export type MutationPolfEventOperatorRevokeArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationPolfEventOperatorSendLinkArgs = {
  id: Scalars["ID"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationPolfEventOperatorSendLinkToAllArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPlayerAddArgs = {
  createPolfEventPlayerDto: CreatePolfEventPlayerDto;
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPlayerAddMultipleArgs = {
  createPolfEventPlayersDto: Array<CreatePolfEventPlayerDto>;
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPlayerDistributeInFlightsArgs = {
  polfEventId: Scalars["ID"]["input"];
  redistributeAll?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationPolfEventPlayerOtherPaymentCreateArgs = {
  polfEventPlayerId: Scalars["ID"]["input"];
};

export type MutationPolfEventPlayerOtherPaymentDeleteArgs = {
  polfEventPlayerOtherPaymentId: Scalars["ID"]["input"];
};

export type MutationPolfEventPlayerPaymentReminderArgs = {
  polfEventPlayerId: Scalars["ID"]["input"];
};

export type MutationPolfEventPlayerRemoveArgs = {
  polfEventPlayerId: Scalars["ID"]["input"];
};

export type MutationPolfEventPlayerScoreUpdateArgs = {
  polfEventId: Scalars["ID"]["input"];
  scoreDto: PolfEventScoreDto;
};

export type MutationPolfEventPlayerUpdateArgs = {
  polfEventPlayerId: Scalars["ID"]["input"];
  updatePolfEventPlayerDto: UpdatePolfEventPlayerDto;
};

export type MutationPolfEventPokerAddTableArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerAllowPlayerStackUpdateSetArgs = {
  allowPlayerStackUpdate: Scalars["Boolean"]["input"];
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerBalancingApplyArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerBlindStructureUpdateArgs = {
  input: UpdateBlindStructureInput;
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerBreakTableArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
  tableNumber: Scalars["Int"]["input"];
};

export type MutationPolfEventPokerClockAdjustArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
  remainingSeconds: Scalars["Int"]["input"];
};

export type MutationPolfEventPokerClockPauseArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerClockResumeArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerClockStartArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerFinalTableRedrawArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerFinishArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerLevelAdvanceArgs = {
  direction: LevelDirection;
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerPayoutStructureUpdateArgs = {
  input: UpdatePayoutStructureInput;
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerPhaseEnableArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerPrizePoolUpdateArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
  prizePool?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationPolfEventPokerRemoveLastTableArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerReorderEliminationArgs = {
  direction: ReorderDirection;
  polfEventId: Scalars["ID"]["input"];
  seatId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerSeatEliminateArgs = {
  knockedOutByPlayerId?: InputMaybe<Scalars["ID"]["input"]>;
  polfEventId: Scalars["ID"]["input"];
  seatId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerSeatLockToggleArgs = {
  isLocked: Scalars["Boolean"]["input"];
  polfEventId: Scalars["ID"]["input"];
  seatId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerSeatMoveArgs = {
  input: MoveSeatInput;
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerSeatRestoreArgs = {
  polfEventId: Scalars["ID"]["input"];
  seatId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerSeatStackUpdateArgs = {
  currentStack: Scalars["Float"]["input"];
  polfEventId: Scalars["ID"]["input"];
  seatId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerSeatSwapArgs = {
  input: SwapSeatsInput;
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerSeatWithdrawArgs = {
  polfEventId: Scalars["ID"]["input"];
  seatId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerSeatsPerTableUpdateArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
  seatsPerTable: Scalars["Float"]["input"];
};

export type MutationPolfEventPokerSendSeatSmsArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
  sender?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationPolfEventPokerShowChipLeaderboardSetArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
  showChipLeaderboard: Scalars["Boolean"]["input"];
};

export type MutationPolfEventPokerStartArgs = {
  input: StartPokerPhaseInput;
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventPokerUsePayoutsSetArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
  usePayouts: Scalars["Boolean"]["input"];
};

export type MutationPolfEventPokerVoiceAnnouncementsSetArgs = {
  pokerId: Scalars["ID"]["input"];
  polfEventId: Scalars["ID"]["input"];
  voiceAnnouncements: Scalars["Boolean"]["input"];
};

export type MutationPolfEventPublicAddPlayerVippsArgs = {
  createPolfEventPaymentDto: CreatePolfEventPaymentDto;
  polfEventId: Scalars["ID"]["input"];
  polfEventPlayerNanoId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationPolfEventPublicUpdatePlayerArgs = {
  polfEventId: Scalars["ID"]["input"];
  polfEventPlayerNanoId: Scalars["String"]["input"];
  updatePolfEventPlayerDto: UpdatePolfEventPlayerDto;
};

export type MutationPolfEventReopenPolfEventArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventRequestUpdatedInfoArgs = {
  onlyInvalid?: InputMaybe<Scalars["Boolean"]["input"]>;
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventSendInvitesArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventStartPolfEventArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventTeamAddArgs = {
  createPolfEventTeamDto?: InputMaybe<CreatePolfEventTeamDto>;
  polfEventId: Scalars["ID"]["input"];
};

export type MutationPolfEventTeamAddPlayerArgs = {
  polfEventPlayerId: Scalars["ID"]["input"];
  polfEventTeamId: Scalars["ID"]["input"];
};

export type MutationPolfEventTeamAutogenerateArgs = {
  polfEventId: Scalars["ID"]["input"];
  teamSize: Scalars["Float"]["input"];
};

export type MutationPolfEventTeamDeleteArgs = {
  polfEventTeamId: Scalars["ID"]["input"];
};

export type MutationPolfEventTeamDistributeInFlightsArgs = {
  polfEventId: Scalars["ID"]["input"];
  redistributeAll?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationPolfEventTeamRemovePlayerArgs = {
  polfEventPlayerId: Scalars["ID"]["input"];
  polfEventTeamId: Scalars["ID"]["input"];
};

export type MutationPolfEventTeamResetNameArgs = {
  polfEventTeamId: Scalars["ID"]["input"];
};

export type MutationPolfEventTeamSetCaptainArgs = {
  polfEventPlayerId: Scalars["ID"]["input"];
  polfEventTeamId: Scalars["ID"]["input"];
};

export type MutationPolfEventTeamUpdateArgs = {
  polfEventTeamId: Scalars["ID"]["input"];
  updatePolfEventTeamDto: UpdatePolfEventTeamDto;
};

export type MutationPolfEventUpdateArgs = {
  polfEventId: Scalars["ID"]["input"];
  updatePolfEventDto: UpdatePolfEventDto;
};

export type MutationSelectAccountArgs = {
  accountId: Scalars["ID"]["input"];
};

export type MutationSendSmsArgs = {
  sendSmsDto: SendSmsDto;
};

export type MutationSponsorCreateArgs = {
  name: Scalars["String"]["input"];
  polfEventId: Scalars["ID"]["input"];
};

export type MutationSponsorDeleteArgs = {
  sponsorId: Scalars["ID"]["input"];
};

export type MutationSponsorLogoUploadCompleteArgs = {
  sponsorId: Scalars["ID"]["input"];
  storagePath: Scalars["String"]["input"];
};

export type MutationSponsorLogoUploadUrlArgs = {
  contentType: Scalars["String"]["input"];
  sponsorId: Scalars["ID"]["input"];
};

export type MutationSponsorUpdateArgs = {
  sponsorId: Scalars["ID"]["input"];
  updateSponsorDto: UpdateSponsorDto;
};

export type OperatorBulkSendResult = {
  __typename?: "OperatorBulkSendResult";
  sent: Scalars["Int"]["output"];
  skippedNoPhone: Scalars["Int"]["output"];
};

export type OperatorPokerView = {
  __typename?: "OperatorPokerView";
  poker: Maybe<PolfEventPoker>;
  role: OperatorRole;
};

export enum OperatorRole {
  BtpPro = "BTP_PRO",
  Dealer = "DEALER",
  PokerTd = "POKER_TD",
  ScoreKeeper = "SCORE_KEEPER",
}

export type PayoutRowInput = {
  percentageBp: Scalars["Int"]["input"];
  position: Scalars["Int"]["input"];
};

export type PolfBeatTheProExtraLeaderboard = {
  __typename?: "PolfBeatTheProExtraLeaderboard";
  allIn: Scalars["Boolean"]["output"];
  bet: Scalars["Float"]["output"];
  state: BeatTheProEntryStateEnum;
  value: Scalars["Float"]["output"];
};

export type PolfEvent = {
  __typename?: "PolfEvent";
  account: Account;
  allowsPublicRegistration: Scalars["Boolean"]["output"];
  chipValues: PolfEventChipValues;
  course: Course;
  createdAt: Scalars["DateTime"]["output"];
  date: Scalars["DateTime"]["output"];
  flightCount: Scalars["Int"]["output"];
  flights: Maybe<Array<PolfEventFlight>>;
  hcpFactor: Scalars["Float"]["output"];
  holeCompetitions: Maybe<Array<PolfEventHoleCompetition>>;
  id: Scalars["ID"]["output"];
  isBestBall: Scalars["Boolean"]["output"];
  isEditable: Scalars["Boolean"]["output"];
  isReadOnly: Scalars["Boolean"]["output"];
  isScramble: Scalars["Boolean"]["output"];
  mode: PolfEventModeEnum;
  name: Scalars["String"]["output"];
  nanoId: Maybe<Scalars["String"]["output"]>;
  playerCount: Scalars["Int"]["output"];
  players: Maybe<Array<PolfEventPlayer>>;
  publicUrl: Maybe<Scalars["String"]["output"]>;
  ranking: Maybe<PolfEventRankingEnum>;
  registration: Maybe<PolfEventRegistration>;
  status: PolfEventStatusEnum;
  teamCount: Scalars["Int"]["output"];
  teams: Maybe<Array<PolfEventTeam>>;
  updatedAt: Scalars["DateTime"]["output"];
  usePokerPhase: Scalars["Boolean"]["output"];
};

export type PolfEventBeatTheProPlayer = {
  __typename?: "PolfEventBeatTheProPlayer";
  entry: Maybe<PolfEventHoleCompetitionEntry>;
  flight: Maybe<PolfEventFlight>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type PolfEventChipValues = {
  __typename?: "PolfEventChipValues";
  birdie: Scalars["Float"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  eagle: Scalars["Float"]["output"];
  flightBonus: Scalars["Float"]["output"];
  flightBonusEnabled: Scalars["Boolean"]["output"];
  holeInOne: Scalars["Float"]["output"];
  id: Scalars["ID"]["output"];
  polfEvent: PolfEvent;
  stablefordPoint: Scalars["Float"]["output"];
  startStack: Scalars["Float"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type PolfEventConsent = {
  __typename?: "PolfEventConsent";
  consentKey: Scalars["String"]["output"];
  consentText: Scalars["String"]["output"];
  consentedAt: Scalars["DateTime"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  payment: Maybe<VippsPayment>;
  player: Maybe<PolfEventPlayer>;
  type: PolfEventConsentTypeEnum;
  updatedAt: Scalars["DateTime"]["output"];
  withdrawnAt: Maybe<Scalars["DateTime"]["output"]>;
};

export enum PolfEventConsentTypeEnum {
  Communication = "COMMUNICATION",
  Sharing = "SHARING",
  Terms = "TERMS",
}

export type PolfEventCopyDataDto = {
  players: Scalars["Boolean"]["input"];
  sourcePolfEventId: Scalars["ID"]["input"];
};

export type PolfEventFlight = {
  __typename?: "PolfEventFlight";
  createdAt: Scalars["DateTime"]["output"];
  flightNumber: Scalars["Float"]["output"];
  id: Scalars["ID"]["output"];
  playerCount: Scalars["Float"]["output"];
  players: Maybe<Array<PolfEventPlayer>>;
  startHole: Maybe<CourseHole>;
  startTime: Maybe<Scalars["String"]["output"]>;
  teams: Maybe<Array<PolfEventTeam>>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type PolfEventHoleCompetition = {
  __typename?: "PolfEventHoleCompetition";
  chipValue: Scalars["Float"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  description: Scalars["String"]["output"];
  entries: Maybe<Array<PolfEventHoleCompetitionEntry>>;
  hole: CourseHole;
  id: Scalars["ID"]["output"];
  /** Only used if comp type is BeatThePro */
  opponent: Maybe<PolfEventHoleCompetitionOpponent>;
  polfEvent: PolfEvent;
  type: PolfEventHoleCompetitionTypeEnum;
  updatedAt: Scalars["DateTime"]["output"];
};

export type PolfEventHoleCompetitionEntry = {
  __typename?: "PolfEventHoleCompetitionEntry";
  /** Only used for competition type Beat the pro */
  beatTheProExtra: Maybe<BeatTheProExtra>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  polfEventHoleCompetition: PolfEventHoleCompetition;
  polfEventPlayer: PolfEventPlayer;
  updatedAt: Scalars["DateTime"]["output"];
  /** Distance in cm/meter if closest/longest, or chip value if beat the pro */
  value: Scalars["Float"]["output"];
};

export type PolfEventHoleCompetitionOpponent = {
  __typename?: "PolfEventHoleCompetitionOpponent";
  countryCode: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  holeCompetition: PolfEventHoleCompetition;
  id: Scalars["ID"]["output"];
  mobileNumber: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  nanoId: Maybe<Scalars["String"]["output"]>;
  smsInviteStatus: Maybe<SmsStatusEnum>;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum PolfEventHoleCompetitionTypeEnum {
  Beatthepro = "BEATTHEPRO",
  Closest = "CLOSEST",
  Longest = "LONGEST",
}

export type PolfEventMobilePlayerHoleCompetition = {
  __typename?: "PolfEventMobilePlayerHoleCompetition";
  chipValue: Scalars["Float"]["output"];
  currentLeader: Maybe<PolfEventHoleCompetitionEntry>;
  description: Scalars["String"]["output"];
  entries: Maybe<Array<PolfEventHoleCompetitionEntry>>;
  hole: CourseHole;
  id: Scalars["ID"]["output"];
  polfEvent: PolfEvent;
  type: PolfEventHoleCompetitionTypeEnum;
};

export type PolfEventMobileScore = {
  __typename?: "PolfEventMobileScore";
  accumulated: PolfEventMobileScoreAccumulated;
  hcp: Maybe<Scalars["Float"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  scores: Maybe<Array<PolfEventScore>>;
  strokes: Scalars["Float"]["output"];
  team: Maybe<PolfEventTeam>;
  /** Only populated when bestball */
  teamAccumulated: Maybe<PolfEventMobileScoreAccumulated>;
  /** Only populated when bestball */
  teamScores: Maybe<Array<PolfEventScore>>;
};

export type PolfEventMobileScoreAccumulated = {
  __typename?: "PolfEventMobileScoreAccumulated";
  chips: Scalars["Float"]["output"];
  holesPlayed: Scalars["Float"]["output"];
  isAllIn: Scalars["Boolean"]["output"];
  score: Scalars["Float"]["output"];
  stablefordPoints: Scalars["Float"]["output"];
  strokes: Scalars["Float"]["output"];
  strokesNet: Scalars["Float"]["output"];
};

export enum PolfEventModeEnum {
  Bestball = "BESTBALL",
  Golf = "GOLF",
  Polf = "POLF",
  Scramble = "SCRAMBLE",
}

export type PolfEventOperator = {
  __typename?: "PolfEventOperator";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  label: Maybe<Scalars["String"]["output"]>;
  nanoId: Scalars["String"]["output"];
  opponentId: Maybe<Scalars["ID"]["output"]>;
  phone: Maybe<Scalars["String"]["output"]>;
  polfEvent: PolfEvent;
  revokedAt: Maybe<Scalars["DateTime"]["output"]>;
  role: OperatorRole;
  tableNumber: Maybe<Scalars["Int"]["output"]>;
};

export type PolfEventOperatorCreateDto = {
  label?: InputMaybe<Scalars["String"]["input"]>;
  opponentId?: InputMaybe<Scalars["ID"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  polfEventId: Scalars["ID"]["input"];
  role: OperatorRole;
  tableNumber?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PolfEventPlayer = {
  __typename?: "PolfEventPlayer";
  consents: Maybe<Array<PolfEventConsent>>;
  countryCode: Scalars["String"]["output"];
  courseTee: CourseTee;
  createdAt: Scalars["DateTime"]["output"];
  email: Maybe<Scalars["String"]["output"]>;
  flight: Maybe<PolfEventFlight>;
  hcp: Maybe<Scalars["Float"]["output"]>;
  id: Scalars["ID"]["output"];
  memberNo: Maybe<Scalars["String"]["output"]>;
  mobileNumber: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  nanoId: Maybe<Scalars["String"]["output"]>;
  payment: Maybe<PolfEventPlayerPaymentUnion>;
  polfEvent: PolfEvent;
  recruitment: Maybe<PolfEventPlayerRecruitment>;
  scores: Maybe<Array<PolfEventScore>>;
  scoresApproved: Scalars["Boolean"]["output"];
  scoresSubmitted: Scalars["Boolean"]["output"];
  sentSms: Maybe<Array<SentSms>>;
  smsInviteStatus: Maybe<SmsStatusEnum>;
  strokes: Scalars["Float"]["output"];
  team: Maybe<PolfEventTeam>;
  updatedAt: Scalars["DateTime"]["output"];
  valid: Scalars["Boolean"]["output"];
};

export type PolfEventPlayerOtherPayment = {
  __typename?: "PolfEventPlayerOtherPayment";
  createdAt: Scalars["DateTime"]["output"];
  createdBy: User;
  id: Scalars["ID"]["output"];
  player: PolfEventPlayer;
  updatedAt: Scalars["DateTime"]["output"];
};

export type PolfEventPlayerPaymentUnion =
  PolfEventPlayerOtherPayment | VippsPayment;

export type PolfEventPlayerRecruitment = {
  __typename?: "PolfEventPlayerRecruitment";
  amountInCents: Scalars["Float"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  player: PolfEventPlayer;
  recruitedBy: Scalars["String"]["output"];
  status: PolfEventPlayerRecruitmentStatusEnum;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum PolfEventPlayerRecruitmentStatusEnum {
  Approved = "APPROVED",
  Registered = "REGISTERED",
  Rejected = "REJECTED",
}

export type PolfEventPoker = {
  __typename?: "PolfEventPoker";
  allowPlayerStackUpdate: Scalars["Boolean"]["output"];
  balancingSuggestion: Maybe<BalancingSuggestionDto>;
  clockStartedAt: Maybe<Scalars["DateTime"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  currentInBreak: Scalars["Boolean"]["output"];
  currentLevelIndex: Scalars["Int"]["output"];
  currentLevelPausedAt: Maybe<Scalars["DateTime"]["output"]>;
  currentLevelStartedAt: Maybe<Scalars["DateTime"]["output"]>;
  finalTableRedrawnAt: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  levels: Array<PolfEventPokerLevel>;
  payouts: Array<PolfEventPokerPayout>;
  polfEvent: PolfEvent;
  prizePool: Maybe<Scalars["Int"]["output"]>;
  seats: Array<PolfEventPokerSeat>;
  seatsPerTable: Scalars["Int"]["output"];
  seedSeatRandom: Scalars["Int"]["output"];
  showChipLeaderboard: Scalars["Boolean"]["output"];
  status: PolfEventPokerStatusEnum;
  tableCount: Scalars["Int"]["output"];
  totalPausedMs: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  usePayouts: Scalars["Boolean"]["output"];
  voiceAnnouncements: Scalars["Boolean"]["output"];
};

export type PolfEventPokerLevel = {
  __typename?: "PolfEventPokerLevel";
  ante: Scalars["Int"]["output"];
  bigBlind: Scalars["Int"]["output"];
  breakAfterMinutes: Maybe<Scalars["Int"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  durationMinutes: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  index: Scalars["Int"]["output"];
  smallBlind: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type PolfEventPokerLevelPublic = {
  __typename?: "PolfEventPokerLevelPublic";
  ante: Scalars["Int"]["output"];
  bigBlind: Scalars["Int"]["output"];
  breakAfterMinutes: Maybe<Scalars["Int"]["output"]>;
  durationMinutes: Scalars["Int"]["output"];
  smallBlind: Scalars["Int"]["output"];
};

export type PolfEventPokerPayout = {
  __typename?: "PolfEventPokerPayout";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  percentageBp: Scalars["Int"]["output"];
  position: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type PolfEventPokerPlayerPayout = {
  __typename?: "PolfEventPokerPlayerPayout";
  percentageBp: Scalars["Int"]["output"];
  position: Scalars["Int"]["output"];
};

export type PolfEventPokerPlayerSeat = {
  __typename?: "PolfEventPokerPlayerSeat";
  currentStack: Scalars["Int"]["output"];
  eliminated: Scalars["Boolean"]["output"];
  finishingPosition: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  seatNumber: Scalars["Int"]["output"];
  startingStack: Scalars["Int"]["output"];
  tableNumber: Scalars["Int"]["output"];
};

export type PolfEventPokerPlayerTableSeat = {
  __typename?: "PolfEventPokerPlayerTableSeat";
  eliminated: Scalars["Boolean"]["output"];
  finishingPosition: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  isYou: Scalars["Boolean"]["output"];
  seatNumber: Scalars["Int"]["output"];
  shortName: Scalars["String"]["output"];
  startingStack: Scalars["Int"]["output"];
};

export type PolfEventPokerPlayerView = {
  __typename?: "PolfEventPokerPlayerView";
  activeStandings: Array<PolfEventPokerPublicActive>;
  allowPlayerStackUpdate: Scalars["Boolean"]["output"];
  averageStack: Maybe<Scalars["Int"]["output"]>;
  currentInBreak: Maybe<Scalars["Boolean"]["output"]>;
  currentLevel: Maybe<PolfEventPokerLevelPublic>;
  currentLevelIndex: Maybe<Scalars["Int"]["output"]>;
  currentLevelPausedAt: Maybe<Scalars["DateTime"]["output"]>;
  currentLevelStartedAt: Maybe<Scalars["DateTime"]["output"]>;
  eliminations: Array<PolfEventPokerPublicEliminated>;
  eventName: Scalars["String"]["output"];
  nextLevel: Maybe<PolfEventPokerLevelPublic>;
  payouts: Array<PolfEventPokerPlayerPayout>;
  playersLeft: Maybe<Scalars["Int"]["output"]>;
  playersTotal: Maybe<Scalars["Int"]["output"]>;
  prizePool: Maybe<Scalars["Int"]["output"]>;
  seat: Maybe<PolfEventPokerPlayerSeat>;
  status: Maybe<PolfEventPokerStatusEnum>;
  tableSeats: Array<PolfEventPokerPlayerTableSeat>;
  usePayouts: Scalars["Boolean"]["output"];
};

export type PolfEventPokerPublicActive = {
  __typename?: "PolfEventPokerPublicActive";
  currentStack: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  isLocked: Scalars["Boolean"]["output"];
  playerName: Scalars["String"]["output"];
  seatNumber: Scalars["Int"]["output"];
  tableNumber: Scalars["Int"]["output"];
};

export type PolfEventPokerPublicDto = {
  __typename?: "PolfEventPokerPublicDto";
  activeStandings: Array<PolfEventPokerPublicActive>;
  averageStartingStack: Scalars["Int"]["output"];
  currentInBreak: Scalars["Boolean"]["output"];
  currentLevel: Maybe<PolfEventPokerLevelPublic>;
  currentLevelIndex: Scalars["Int"]["output"];
  currentLevelPausedAt: Maybe<Scalars["DateTime"]["output"]>;
  currentLevelStartedAt: Maybe<Scalars["DateTime"]["output"]>;
  eliminations: Array<PolfEventPokerPublicEliminated>;
  eventName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  nextLevel: Maybe<PolfEventPokerLevelPublic>;
  playersLeft: Scalars["Int"]["output"];
  playersTotal: Scalars["Int"]["output"];
  status: PolfEventPokerStatusEnum;
  totalLevels: Scalars["Int"]["output"];
  voiceAnnouncements: Scalars["Boolean"]["output"];
};

export type PolfEventPokerPublicEliminated = {
  __typename?: "PolfEventPokerPublicEliminated";
  eliminatedAt: Maybe<Scalars["DateTime"]["output"]>;
  finishingPosition: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  playerName: Scalars["String"]["output"];
  seatNumber: Scalars["Int"]["output"];
  tableNumber: Scalars["Int"]["output"];
};

export type PolfEventPokerSeat = {
  __typename?: "PolfEventPokerSeat";
  createdAt: Scalars["DateTime"]["output"];
  currentStack: Scalars["Int"]["output"];
  eliminated: Scalars["Boolean"]["output"];
  eliminatedAt: Maybe<Scalars["DateTime"]["output"]>;
  eliminatedByOperatorId: Maybe<Scalars["ID"]["output"]>;
  eliminatedByUserId: Maybe<Scalars["ID"]["output"]>;
  finishingPosition: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  isLocked: Scalars["Boolean"]["output"];
  knockedOutByPlayer: Maybe<PolfEventPlayer>;
  polfEventPlayer: PolfEventPlayer;
  seatNumber: Scalars["Int"]["output"];
  startingStack: Scalars["Int"]["output"];
  tableNumber: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  withdrawn: Scalars["Boolean"]["output"];
};

export type PolfEventPokerSmsResult = {
  __typename?: "PolfEventPokerSmsResult";
  failedCount: Scalars["Int"]["output"];
  sentCount: Scalars["Int"]["output"];
};

export enum PolfEventPokerStatusEnum {
  Finished = "FINISHED",
  NotStarted = "NOT_STARTED",
  Paused = "PAUSED",
  Running = "RUNNING",
  Seated = "SEATED",
}

export type PolfEventPrice = {
  __typename?: "PolfEventPrice";
  /** Amount in cents. */
  amountInCents: Scalars["Float"]["output"];
};

export type PolfEventPriceDto = {
  /** Amount in cents. */
  amountInCents: Scalars["Float"]["input"];
};

export enum PolfEventRankingEnum {
  NetStrokes = "NET_STROKES",
  Stableford = "STABLEFORD",
}

export type PolfEventRegistration = {
  __typename?: "PolfEventRegistration";
  enabled: Scalars["Boolean"]["output"];
  /** When true, the registration form lets the player pick their tee. Default (unset/false): the course default tee is auto-assigned. */
  playerPicksTee: Maybe<Scalars["Boolean"]["output"]>;
  price: PolfEventPrice;
  recruitment: Maybe<PolfEventRegistrationRecruitment>;
};

export type PolfEventRegistrationDto = {
  enabled: Scalars["Boolean"]["input"];
  /** When true, the registration form lets the player pick their tee. Default (unset/false): the course default tee is auto-assigned. */
  playerPicksTee?: InputMaybe<Scalars["Boolean"]["input"]>;
  price: PolfEventPriceDto;
  recruitment?: InputMaybe<PolfEventRegistrationRecruitmentDto>;
};

export type PolfEventRegistrationRecruitment = {
  __typename?: "PolfEventRegistrationRecruitment";
  /** Amount in cents. */
  amountInCents: Scalars["Float"]["output"];
  enabled: Scalars["Boolean"]["output"];
};

export type PolfEventRegistrationRecruitmentDto = {
  /** Amount in cents. */
  amountInCents: Scalars["Float"]["input"];
  enabled: Scalars["Boolean"]["input"];
};

export type PolfEventScore = {
  __typename?: "PolfEventScore";
  approved: Scalars["Boolean"]["output"];
  chips: Scalars["Float"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  hole: CourseHole;
  id: Scalars["ID"]["output"];
  isBirdie: Scalars["Boolean"]["output"];
  isBogey: Scalars["Boolean"]["output"];
  isDoubleBogeyOrWorse: Scalars["Boolean"]["output"];
  isEagleOrBetter: Scalars["Boolean"]["output"];
  netScore: Maybe<Scalars["Float"]["output"]>;
  player: Maybe<PolfEventPlayer>;
  score: Maybe<Scalars["Float"]["output"]>;
  stablefordPoints: Scalars["Float"]["output"];
  strokes: Scalars["Float"]["output"];
  submitted: Scalars["Boolean"]["output"];
  team: Maybe<PolfEventTeam>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type PolfEventScoreDto = {
  polfEventScoreId: Scalars["ID"]["input"];
  score: Scalars["Float"]["input"];
};

export enum PolfEventStatusEnum {
  Closed = "CLOSED",
  Draft = "DRAFT",
  Finished = "FINISHED",
  Started = "STARTED",
}

export type PolfEventTeam = {
  __typename?: "PolfEventTeam";
  captain: Maybe<PolfEventPlayer>;
  createdAt: Scalars["DateTime"]["output"];
  flight: Maybe<PolfEventFlight>;
  id: Scalars["ID"]["output"];
  name: Maybe<Scalars["String"]["output"]>;
  players: Maybe<Array<PolfEventPlayer>>;
  polfEvent: PolfEvent;
  scores: Maybe<Array<PolfEventScore>>;
  strokes: Maybe<Scalars["Float"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  valid: Scalars["Boolean"]["output"];
};

export type PolfLeaderboard = {
  __typename?: "PolfLeaderboard";
  flights: Array<PolfLeaderboardFlight>;
  players: Array<PolfLeaderboardPlayer>;
};

export type PolfLeaderboardFlight = {
  __typename?: "PolfLeaderboardFlight";
  chips: Scalars["Float"]["output"];
  flightNumber: Scalars["Float"]["output"];
  players: Array<PolfLeaderboardPlayer>;
  rank: Scalars["Float"]["output"];
};

export type PolfLeaderboardPlayer = {
  __typename?: "PolfLeaderboardPlayer";
  beatTheProExtra: Maybe<PolfBeatTheProExtraLeaderboard>;
  birdies: PolfLeaderboardSpecialEntry;
  chips: Scalars["Float"]["output"];
  chipsInclHoleCompetitions: Scalars["Float"]["output"];
  closest: PolfLeaderboardSpecialEntry;
  eagles: PolfLeaderboardSpecialEntry;
  flightBonus: Maybe<Scalars["Float"]["output"]>;
  holeInOnes: PolfLeaderboardSpecialEntry;
  holesRegistred: Scalars["Float"]["output"];
  isAllIn: Maybe<Scalars["Boolean"]["output"]>;
  longest: PolfLeaderboardSpecialEntry;
  player: PolfEventPlayer;
  rank: Maybe<Scalars["Float"]["output"]>;
  scores: Array<PolfEventScore>;
  stablefordPoints: PolfLeaderboardSpecialEntry;
  startStack: Scalars["Float"]["output"];
};

export type PolfLeaderboardSpecialEntry = {
  __typename?: "PolfLeaderboardSpecialEntry";
  chips: Scalars["Float"]["output"];
  count: Scalars["Float"]["output"];
};

export type Query = {
  __typename?: "Query";
  accountMembers: Array<AccountMember>;
  accountSettings: AccountSettingsType;
  accounts: Array<Account>;
  brregSearch: Array<BrregCompanyType>;
  course: Course;
  courseTees: Array<CourseTee>;
  courses: Array<Course>;
  currentOpponent: PolfEventHoleCompetitionOpponent;
  currentOpponentHoleCompetitions: Array<PolfEventMobilePlayerHoleCompetition>;
  currentOpponentPlayers: Array<PolfEventBeatTheProPlayer>;
  currentPlayer: PolfEventPlayer;
  currentPlayerFlightScores: Array<PolfEventMobileScore>;
  currentPlayerHoleCompetitions: Array<PolfEventMobilePlayerHoleCompetition>;
  currentPlayerLeaderBoard: LeaderboardUnion;
  currentPlayerPokerView: PolfEventPokerPlayerView;
  currentPolfEventPublic: PolfEvent;
  devToolsEnabled: Scalars["Boolean"]["output"];
  eventSponsors: Array<Sponsor>;
  findCourseDraft: CourseDraftDto;
  me: User;
  myAccountMembers: Array<AccountMember>;
  myAccountSettings: AccountSettingsType;
  myAccounts: Array<AccountMember>;
  myCurrentAccount: Account;
  operatorPokerView: OperatorPokerView;
  payment: VippsPayment;
  paymentDetails: VippsPaymentDetails;
  payments: Array<VippsPayment>;
  polfEvent: PolfEvent;
  polfEventFlights: Array<PolfEventFlight>;
  polfEventHoleCompetitions: Array<PolfEventHoleCompetition>;
  polfEventLeaderboard: LeaderboardUnion;
  polfEventOperatorList: Array<PolfEventOperator>;
  polfEventPlayerOtherPayment: PolfEventPlayerOtherPayment;
  polfEventPlayers: Array<PolfEventPlayer>;
  polfEventPoker: Maybe<PolfEventPoker>;
  polfEventPokerPublic: Maybe<PolfEventPokerPublicDto>;
  polfEventPublicHoleCompetitionsWithCurrentLeader: Array<PolfEventMobilePlayerHoleCompetition>;
  polfEventPublicLeaderboard: LeaderboardUnion;
  polfEventPublicPlayer: PolfEventPlayer;
  polfEventScorecard: Array<PolfEventPlayer>;
  polfEventSponsorsPublic: Array<Sponsor>;
  polfEventTeams: Array<PolfEventTeam>;
  polfEvents: Array<PolfEvent>;
  smsAccountInfo: SmsMeResponse;
  smsHistory: Array<SentSms>;
};

export type QueryAccountMembersArgs = {
  accountId: Scalars["ID"]["input"];
};

export type QueryAccountSettingsArgs = {
  accountId: Scalars["ID"]["input"];
};

export type QueryBrregSearchArgs = {
  searchTerm: Scalars["String"]["input"];
};

export type QueryCourseArgs = {
  courseId: Scalars["ID"]["input"];
};

export type QueryCourseTeesArgs = {
  courseId: Scalars["ID"]["input"];
};

export type QueryCurrentOpponentHoleCompetitionsArgs = {
  holeCompetitionType: Array<PolfEventHoleCompetitionTypeEnum>;
};

export type QueryCurrentPlayerHoleCompetitionsArgs = {
  holeCompetitionType: Array<PolfEventHoleCompetitionTypeEnum>;
};

export type QueryEventSponsorsArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type QueryFindCourseDraftArgs = {
  country: CourseCountryEnum;
  deepenFromSources?: InputMaybe<Array<Scalars["String"]["input"]>>;
  name: Scalars["String"]["input"];
};

export type QueryPaymentArgs = {
  paymentId: Scalars["ID"]["input"];
};

export type QueryPaymentDetailsArgs = {
  paymentId: Scalars["ID"]["input"];
};

export type QueryPolfEventArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type QueryPolfEventFlightsArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type QueryPolfEventHoleCompetitionsArgs = {
  polfEventHoleCompetitionType: Array<PolfEventHoleCompetitionTypeEnum>;
  polfEventId: Scalars["ID"]["input"];
};

export type QueryPolfEventLeaderboardArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type QueryPolfEventOperatorListArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type QueryPolfEventPlayerOtherPaymentArgs = {
  polfEventPlayerOtherPaymentId: Scalars["ID"]["input"];
};

export type QueryPolfEventPlayersArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type QueryPolfEventPokerArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type QueryPolfEventPokerPublicArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type QueryPolfEventPublicHoleCompetitionsWithCurrentLeaderArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type QueryPolfEventPublicLeaderboardArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type QueryPolfEventPublicPlayerArgs = {
  polfEventId: Scalars["ID"]["input"];
  polfEventPlayerNanoId: Scalars["ID"]["input"];
};

export type QueryPolfEventScorecardArgs = {
  playerIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  polfEventId: Scalars["ID"]["input"];
};

export type QueryPolfEventSponsorsPublicArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type QueryPolfEventTeamsArgs = {
  polfEventId: Scalars["ID"]["input"];
};

export type QuerySmsHistoryArgs = {
  sentSmsFilters?: InputMaybe<SentSmsFilters>;
};

export enum ReorderDirection {
  Down = "DOWN",
  Up = "UP",
}

export type ScrambleLeaderboard = {
  __typename?: "ScrambleLeaderboard";
  teams: Array<ScrambleLeaderboardTeam>;
};

export type ScrambleLeaderboardTeam = {
  __typename?: "ScrambleLeaderboardTeam";
  holesRegistred: Scalars["Float"]["output"];
  points: Scalars["Float"]["output"];
  rank: Maybe<Scalars["Float"]["output"]>;
  score: Scalars["Float"]["output"];
  scores: Array<PolfEventScore>;
  strokes: Scalars["Float"]["output"];
  strokesNet: Scalars["Float"]["output"];
  team: PolfEventTeam;
};

export type SelectAccountResponse = {
  __typename?: "SelectAccountResponse";
  success: Scalars["Boolean"]["output"];
};

export type SendSmsDto = {
  /** Field can be used to group messages together, use case: sending sms in bulk */
  batchId?: InputMaybe<Scalars["String"]["input"]>;
  from?: InputMaybe<Scalars["String"]["input"]>;
  message: Scalars["String"]["input"];
  playerId?: InputMaybe<Scalars["String"]["input"]>;
  to: Scalars["String"]["input"];
  type?: InputMaybe<SmsTypeEnum>;
};

export type SentSms = {
  __typename?: "SentSms";
  batchId: Maybe<Scalars["String"]["output"]>;
  cost: Scalars["Float"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  createdBy: User;
  delivered: Maybe<Scalars["DateTime"]["output"]>;
  direction: Scalars["String"]["output"];
  externalId: Scalars["String"]["output"];
  flashsms: Maybe<Scalars["String"]["output"]>;
  from: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
  player: Maybe<PolfEventPlayer>;
  status: SmsStatusEnum;
  to: Scalars["String"]["output"];
  type: Maybe<SmsTypeEnum>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type SentSmsFilters = {
  showOnlyBatches: Scalars["Boolean"]["input"];
};

export type SmsMeResponse = {
  __typename?: "SmsMeResponse";
  balance: Scalars["Float"]["output"];
  currency: Scalars["String"]["output"];
  displayname: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  mobilenumber: Scalars["String"]["output"];
};

export enum SmsStatusEnum {
  SmsCreated = "SMS_CREATED",
  SmsDelivered = "SMS_DELIVERED",
  SmsDeliveryFailed = "SMS_DELIVERY_FAILED",
  SmsSent = "SMS_SENT",
}

export enum SmsTypeEnum {
  Paymentreminder = "PAYMENTREMINDER",
}

export type Sponsor = {
  __typename?: "Sponsor";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  logoUrl: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type SponsorLogoUpload = {
  __typename?: "SponsorLogoUpload";
  storagePath: Scalars["String"]["output"];
  uploadUrl: Scalars["String"]["output"];
};

export type StartPokerPhaseInput = {
  allowPlayerStackUpdate?: InputMaybe<Scalars["Boolean"]["input"]>;
  blindTemplateKey?: InputMaybe<BlindTemplateKeyEnum>;
  customLevels?: InputMaybe<Array<BlindLevelInput>>;
  seatsPerTable: Scalars["Int"]["input"];
  usePayouts: Scalars["Boolean"]["input"];
};

export type Subscription = {
  __typename?: "Subscription";
  smsEventUpdated: Scalars["Boolean"]["output"];
};

export type SwapSeatsInput = {
  seatAId: Scalars["ID"]["input"];
  seatBId: Scalars["ID"]["input"];
};

export type UpdateAccountProfileInput = {
  addressCity?: InputMaybe<Scalars["String"]["input"]>;
  addressPostalCode?: InputMaybe<Scalars["String"]["input"]>;
  addressStreet?: InputMaybe<Scalars["String"]["input"]>;
  contactEmail?: InputMaybe<Scalars["String"]["input"]>;
  contactPhone?: InputMaybe<Scalars["String"]["input"]>;
  website?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateAccountSettingsInput = {
  brandFooterText?: InputMaybe<Scalars["String"]["input"]>;
  brandLogoUrl?: InputMaybe<Scalars["String"]["input"]>;
  brandPrimaryColor?: InputMaybe<Scalars["String"]["input"]>;
  mailFromName?: InputMaybe<Scalars["String"]["input"]>;
  mailReplyTo?: InputMaybe<Scalars["String"]["input"]>;
  paymentNotificationEmail?: InputMaybe<Scalars["String"]["input"]>;
  privacyUrl?: InputMaybe<Scalars["String"]["input"]>;
  smsDefaultSender?: InputMaybe<Scalars["String"]["input"]>;
  startInvoiceNo?: InputMaybe<Scalars["Float"]["input"]>;
  termsUrl?: InputMaybe<Scalars["String"]["input"]>;
  vippsClientId?: InputMaybe<Scalars["String"]["input"]>;
  vippsClientSecret?: InputMaybe<Scalars["String"]["input"]>;
  vippsMerchantSerialNumber?: InputMaybe<Scalars["String"]["input"]>;
  vippsSubscriptionKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateBlindStructureInput = {
  levels: Array<BlindLevelInput>;
};

export type UpdateCourseDto = {
  country?: InputMaybe<CourseCountryEnum>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateCourseFromDraftDto = {
  holes: Array<CourseDraftHoleInputDto>;
  name: Scalars["String"]["input"];
  tees: Array<CourseDraftTeeInputDto>;
};

export type UpdateCourseHoleDto = {
  index?: InputMaybe<Scalars["Float"]["input"]>;
  number?: InputMaybe<Scalars["Float"]["input"]>;
  par?: InputMaybe<Scalars["Float"]["input"]>;
  tees?: InputMaybe<Array<CourseHoleTeesDto>>;
};

export type UpdateCourseStatusDto = {
  status: CourseStatusEnum;
};

export type UpdateCourseTeeDto = {
  courseRating?: InputMaybe<Scalars["Float"]["input"]>;
  par?: InputMaybe<Scalars["Float"]["input"]>;
  slope?: InputMaybe<Scalars["Float"]["input"]>;
  teeName?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePayoutStructureInput = {
  rows: Array<PayoutRowInput>;
};

export type UpdatePolfEventChipValues = {
  birdie?: InputMaybe<Scalars["Float"]["input"]>;
  eagle?: InputMaybe<Scalars["Float"]["input"]>;
  flightBonus?: InputMaybe<Scalars["Float"]["input"]>;
  holeInOne?: InputMaybe<Scalars["Float"]["input"]>;
  polfEventId?: InputMaybe<Scalars["ID"]["input"]>;
  stablefordPoint?: InputMaybe<Scalars["Float"]["input"]>;
  startStack?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpdatePolfEventDto = {
  courseId?: InputMaybe<Scalars["ID"]["input"]>;
  date?: InputMaybe<Scalars["DateTime"]["input"]>;
  hcpFactor?: InputMaybe<Scalars["Float"]["input"]>;
  mode?: InputMaybe<PolfEventModeEnum>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  ranking?: InputMaybe<PolfEventRankingEnum>;
  registration?: InputMaybe<PolfEventRegistrationDto>;
};

export type UpdatePolfEventFlightDto = {
  startHoleId?: InputMaybe<Scalars["ID"]["input"]>;
  startTime?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePolfEventHoleCompetitionDto = {
  chipValue?: InputMaybe<Scalars["Float"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  holeId?: InputMaybe<Scalars["ID"]["input"]>;
  type?: InputMaybe<PolfEventHoleCompetitionTypeEnum>;
};

export type UpdatePolfEventHoleCompetitionEntryDto = {
  /** Only used for competition type Beat the pro */
  beatTheProExtra?: InputMaybe<BeatTheProExtraDto>;
  polfEventPlayerId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Distance in cm/meter if closest/longest, or chip value if beat the pro */
  value?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpdatePolfEventHoleCompetitionOpponentDto = {
  countryCode?: InputMaybe<Scalars["String"]["input"]>;
  mobileNumber?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePolfEventPlayerDto = {
  countryCode?: InputMaybe<Scalars["String"]["input"]>;
  courseTeeId?: InputMaybe<Scalars["ID"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  hcp?: InputMaybe<Scalars["Float"]["input"]>;
  memberNo?: InputMaybe<Scalars["String"]["input"]>;
  mobileNumber?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  recruitedBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePolfEventTeamDto = {
  customName?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateSponsorDto = {
  name: Scalars["String"]["input"];
};

export type User = {
  __typename?: "User";
  createdAt: Scalars["DateTime"]["output"];
  email: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type VippsPayment = {
  __typename?: "VippsPayment";
  aggregate: Maybe<VippsPaymentDetailsAggregate>;
  amount: Maybe<VippsPaymentDetailsAmount>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  invoiceNo: Maybe<Scalars["Float"]["output"]>;
  mobileNumber: Maybe<Scalars["String"]["output"]>;
  paymentMethod: VippsPaymentMethodEnum;
  paymentStatus: Maybe<VippsPaymentStatusEnum>;
  player: Maybe<PolfEventPlayer>;
  polfEvent: PolfEvent;
  redirectUrl: Maybe<Scalars["String"]["output"]>;
  reference: Maybe<Scalars["String"]["output"]>;
  state: Maybe<Scalars["String"]["output"]>;
  sub: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  userInfo: Maybe<VippsUserInfo>;
};

/** Based on EPaymentGetPaymentResponse from Vipps */
export type VippsPaymentDetails = {
  __typename?: "VippsPaymentDetails";
  aggregate: VippsPaymentDetailsAggregate;
  amount: VippsPaymentDetailsAmount;
  events: Array<VippsPaymentDetailsEvent>;
  paymentRecord: VippsPayment;
  reference: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
};

export type VippsPaymentDetailsAggregate = {
  __typename?: "VippsPaymentDetailsAggregate";
  authorizedAmount: VippsPaymentDetailsAmount;
  cancelledAmount: VippsPaymentDetailsAmount;
  capturedAmount: VippsPaymentDetailsAmount;
  refundedAmount: VippsPaymentDetailsAmount;
};

export type VippsPaymentDetailsAmount = {
  __typename?: "VippsPaymentDetailsAmount";
  currency: Scalars["String"]["output"];
  value: Scalars["Float"]["output"];
};

export type VippsPaymentDetailsEvent = {
  __typename?: "VippsPaymentDetailsEvent";
  amount: VippsPaymentDetailsAmount;
  name: Maybe<Scalars["String"]["output"]>;
  reference: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
  timestamp: Scalars["String"]["output"];
};

export enum VippsPaymentMethodEnum {
  Card = "CARD",
  Wallet = "WALLET",
}

export enum VippsPaymentStatusEnum {
  Aborted = "ABORTED",
  Captured = "CAPTURED",
  Expired = "EXPIRED",
  None = "NONE",
  Refunded = "REFUNDED",
  Reserved = "RESERVED",
}

export type VippsUserInfo = {
  __typename?: "VippsUserInfo";
  address: VippsUserInfoAddress;
  birthdate: Scalars["String"]["output"];
  email: Scalars["String"]["output"];
  email_verified: Scalars["Boolean"]["output"];
  family_name: Scalars["String"]["output"];
  given_name: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  phone_number: Scalars["String"]["output"];
};

export type VippsUserInfoAddress = {
  __typename?: "VippsUserInfoAddress";
  address_type: Scalars["String"]["output"];
  country: Scalars["String"]["output"];
  formatted: Scalars["String"]["output"];
  postal_code: Scalars["String"]["output"];
  region: Scalars["String"]["output"];
  street_address: Scalars["String"]["output"];
};
